import React from "react";
import { motion } from "framer-motion";
import Faqques from "./Faqques";
import Button from "../Components/Button";
import { useNavigate } from "react-router-dom";
import { BRAND } from "../config/brand";

function Faqs() {
  const navigate = useNavigate();

  const questionVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <div className="faqs-main-container">
      <motion.div
        className="faqs-heading"
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <span>FAQS</span>
        <motion.h1
          initial={{ opacity: 0, scale: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          Frequently asked questions
        </motion.h1>
      </motion.div>

      <motion.hr
        className="hr-f"
        initial={{ opacity: 0, scaleX: 0 }}
        whileInView={{ opacity: 1, scaleX: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
      />

      <div className="faqs-questions">
        <motion.div
          variants={questionVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <Faqques
            ques={`What makes ${BRAND.tokenSymbol} different from other stablecoins?`}
            para={`${BRAND.name} is backed by a tangible, high-value asset: a secured reserve of Alexandrite. With auditable reserves, fixed supply discipline, and a transparent value model, ${BRAND.tokenSymbol} is designed for security and long-term trust in the crypto space.`}
          />
        </motion.div>
        <motion.hr
          className="hr-f"
          initial={{ opacity: 0, scaleX: 0 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        />

        <motion.div
          variants={questionVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <Faqques
            ques={`How is the asset backing ${BRAND.tokenSymbol} secured?`}
            para="The  reserve is stored in a high-security vault and certified by the Global Trust Depository (GTD). All assets are independently verifiable, and reserves remain fully auditable to ensure complete transparency and trust."
          />
        </motion.div>
        <motion.hr
          className="hr-f"
          initial={{ opacity: 0, scaleX: 0 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        />

        <motion.div
          variants={questionVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <Faqques
            ques={`Where can I buy and trade ${BRAND.tokenSymbol}?`}
            para={`${BRAND.tokenSymbol} is planned for decentralized exchange access with liquidity mechanisms in place to support smooth trading. More exchange listings will be announced as the ecosystem expands.`}
          />
        </motion.div>
        <motion.hr
          className="hr-f"
          initial={{ opacity: 0, scaleX: 0 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        />

        <motion.div
          variants={questionVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <Faqques
            ques={`Can I redeem Alexandrite by holding ${BRAND.tokenSymbol}?`}
            para="The Alexandrite reserve is designed to support token value and market stability, not individual redemptions. Reserve redemption rights are tied to the complete token supply model to preserve long-term integrity."
          />
        </motion.div>
        <motion.hr
          className="hr-f"
          initial={{ opacity: 0, scaleX: 0 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        />
      </div>

      <motion.div
        className="faq-b"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <h1>Still have questions?</h1>
        <p>Feel free to reach out to our amazing team.</p>
        <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
          <Button
            text="Contact Us"
            className="secondary"
            onClick={() => navigate("/ContactUs")}
          />
        </motion.div>
      </motion.div>
    </div>
  );
}

export default Faqs;
